import { Badge, Button, cn, Stack, Typography } from '@prenuvo/halo';

interface PriorsButtonProps {
  isActive: boolean;
  onClick: () => void;
  priorStudyCount: number;
}

export function PriorsButton({ isActive, onClick, priorStudyCount }: PriorsButtonProps) {
  return (
    <Button
      aria-label={`Priors ${priorStudyCount}`}
      className={{
        root: cn({
          'bg-stone-200 text-stone-950 hover:border-stone-200 hover:bg-stone-200 hover:text-stone-950 dark:bg-stone-200 dark:text-stone-950 hover:dark:border-stone-200 hover:dark:bg-stone-200 hover:dark:text-stone-950':
            isActive,
        }),
      }}
      data-testid="priors-button"
      onClick={onClick}
      size="sm"
      translationKey="FCT.COMPARISON.SIDE_PANEL.BUTTON"
      translationValue={{
        content: (
          <Stack alignment="center">
            <Typography
              className={cn({
                'dark:text-stone-950': isActive,
              })}
              translationKey="FCT.COMPARISON.SIDE_PANEL.PRIORS"
              variant="button-sm"
            />
            <Badge className="dark:bg-blue-500 dark:text-white" value={priorStudyCount} />
          </Stack>
        ),
      }}
      variant="text"
    />
  );
}
